export default __webpack_public_path__ + "static/media/milk2.b2ca488e.jpg";